<template>
  <div>
    <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>

    <div class="row mx-1 mt-1">
      <b-select v-model="perPage" :options="pageOptions" class="pageSizeClass">
      </b-select>
      <b-input 
        id="search-input" 
        class="col-md-6 col-lg-4 ml-2 mb-2 mb-sm-0" 
        :placeholder="$t('parametrics.modulesSearchBy')"
        v-model="searchString"
      ></b-input>
      <router-link :to="{name: 'moduleAdd'}" class="ml-auto">
        <b-button class="esep-blue-bg " variant="primary">
          {{ $t("parametrics.addModule") }}
        </b-button>
      </router-link>
    </div>
    <b-table 
      :items="modules"
      :fields="fields"
      :filter="searchString"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :per-page="perPage"
      :current-page="currentPage"
      responsive
      show-empty
      ref="modulesTable"
      class="mt-2"
      thead-class="esep-blue-bg text-light"
    >      
      <template v-slot:cell(action)="row">
        <b-button
          size="sm"
          @click="editModule(row)"
          variant="transparent"
          :title="$t('parametrics.editModule')"
        >
          <b-icon icon="pencil-square" ></b-icon>
        </b-button>
      </template>

      <template v-slot:empty="">
        <h6>{{ $t("parametrics.emptyModulesTable") }}</h6>
      </template>

    </b-table>

    <b-row>
      <b-col>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          align="right"
          aria-controls="members-table"
          variant="info"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  computed: {
    rows() {
      return this.filteredItems ? this.filteredItems.length : this.modules ? this.modules.length : 0;
    }
  },
  props: {
    modules: Array
  },
  data() {
    return {
      popSuccessAlert: false,
      successMessage: null,
      perPage: 10,
      currentPage: 1,
      pageOptions: [
        10,
        20,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "All",
        },
      ],
      sortBy: "title",
      sortDesc: false,
      fields: [
        { key: "id", label: "Κωδικός", sortable: true },
        { key: "title", label: "Τίτλος", sortable: true, thClass: 'text-left', tdClass: 'text-left' },
        { key: "branch", label: "Κλάδος", sortable: true, sortByFormatted: true, filterByFormatted: true, formatter: "formatBranch", thClass: 'text-left', tdClass: 'text-left'},
        { key: "action", label: "Ενέργεια", sortable: false  }
      ],
      filterOn: ["title", "branch"],
      searchString: "",
      filteredItems: null
    }
  },
  methods: {
    formatBranch(branch) {
      return this.$t(`branchTypeEnums.${branch}`);
    },
    editModule(row) {
      this.$log.debug(row);
      this.$router.push({name: 'moduleEdit',params: { id: row.item.id }});
    },
    onFiltered(filteredItems) {
       if (this.rows !== filteredItems.length) {
          this.filteredItems = filteredItems;
          this.currentPage = 1
        } else {
          this.filteredItems = null
        }
      }
  }
}
</script>